<template>
  <div>
    <div class="g-tile-list">
      <router-link :to="{ name: 'GamePage', params: { id: game.id } }" v-for="game in currentGames" :key="game.id">
        <GameTile :game="game" />
      </router-link>
    </div>
    <div class="has-text-centered">
      <img v-show="loading" src="@/../static/gamega.me/loading.gif" class="is-inline-block m-md m-t-xl" style="height:12rem;" />
    </div>
    <Observer @intersect="loadMore(loop)" />
  </div>
</template>

<script>
import GameTile from '@/components/LangGG/GameTile'
import Observer from '@/components/Observer'

export default {
  name: 'GameTileList',
  props: {
    games: Array,
    first: {
      type: Number,
      default: 12
    },
    loop: {
      type: Number,
      default: 6
    }
  },
  data () {
    const currentGames = this.games.slice(0, this.first)
    return {
      currentGames,
      loading: false
    }
  },
  methods: {
    loadMore (n) {
      const gamesLength = this.games.length
      const currentGamesLength = this.currentGames.length
      if (this.loading === false) {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          for (let i = 0; i < n; i++) {
            this.currentGames.push(this.games[(currentGamesLength + i) % gamesLength])
          }
        }, 600)
      }
    }
  },
  components: {
    GameTile,
    Observer
  }
}
</script>

<style>
.g-tile-list {
  display: grid;
  grid-template-columns: repeat(1,minmax(0,1fr));
  gap: 0.5rem;
}
@media (min-width: 600px) { 
  .g-tile-list {
    grid-template-columns: repeat(2,minmax(0,1fr));
    gap: 1rem;
  }
}
@media (min-width: 900px) { 
  .g-tile-list {
    grid-template-columns: repeat(3,minmax(0,1fr));
    gap: 1.5rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LangGG/GameTileList.vue